import enGB from "./en-gb";
import it from "./it";
import es from "./es";
import deDe from "./de-de";
export default {
  'en-gb': enGB,
  it: it,
  es: es,
  'de-de': deDe
};